import { BlobFileInfo } from "../File";

export class LessonDto{
    id!:string;
    title!:string;
    videoUrl!:string;
    description!:string;
    materialUrl!:string;
    materials:BlobFileInfo[] = [];
    order!:number;
    moduleId!:string;
    isActive!:boolean;
}
export class LessonCreateDto{
    title!:string;
    moduleId!:string;
    description!:string;
}